import SingularityAccount from "./SingularityAccount";
import AcceptServiceAgreement from "./AcceptServiceAgreement";
import Organization from "./Authenticate/Organization";
import Invitee from "./Authenticate/Invitee";
import { Navigate } from "react-router";

export const onboardingRoutes = {
    DEFAULT_PAGE: {
        name: "default",
        path: "",
        index: true,
        element: <Navigate to="/onboarding/agreement" replace />,
    },
    ACCEPT_SERVICE_AGREEMENT: {
        name: "accept service agreement",
        path: "agreement",
        element: <AcceptServiceAgreement />,
    },
    SINGULARITY_ACCOUNT: {
        name: "singularitynet account",
        path: "singularityaccount",
        element: <SingularityAccount />,
    },
    ORGANIZATION: {
        name: "organization",
        path: "organization",
        element: <Organization />,
    },
    INVITEE: {
        name: "invitee",
        path: "acceptinvite",
        element: <Invitee />,
    },
};

export const {
    DEFAULT_PAGE,
    SINGULARITY_ACCOUNT,
    ACCEPT_SERVICE_AGREEMENT,
    ORGANIZATION,
    INVITEE,
} = onboardingRoutes;
